import {ENDPOINT_ATTACHMENT} from 'common/endpoints';
import {commonJwtHeader, usePresignedUrl} from 'common/utils';
import goStore from 'go/store';
import _ from 'lodash';

const deleteAttachment = (token, resourceId) => {
  const baseUrl = ENDPOINT_ATTACHMENT;
  return fetch(`${baseUrl}resource/${encodeURIComponent(resourceId)}`, {
    method: 'DELETE',
    headers: commonJwtHeader(),
  });
};

const callGetAttachmentsByEntityIdAndEntityTypeAndAttachmentType = ({
  token,
  entityId,
  entityType,
  attachmentType,
}) => {
  const baseUrl = ENDPOINT_ATTACHMENT;
  const endpointToUse = `${baseUrl}entity/${entityId}/entityType/${entityType}/attachmentType/${attachmentType}`;
  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getAttachmentsByEntityIdAndEntityType = (token, entityId, entityType) => {
  const baseUrl = ENDPOINT_ATTACHMENT;
  const endpointToUse = `${baseUrl}entity/${entityId}/entityType/${entityType}`;
  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getAttachmentDownloadPresignedUrl = (resourceId) => {
  const baseUrl = ENDPOINT_ATTACHMENT;
  const endpointToUse = `${baseUrl}resource/${encodeURIComponent(resourceId)}`;
  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};
const getAttachmentDownloadUrl = (resourceId) => {
  const state = goStore.store.getState();
  const csrftoken = _.get(state, 'auth.token._csrftoken');
  const v2 = _.includes(_.get(state, 'toggles.toggles'), 'attachmentResourceV2')
    ? 'V2'
    : '';
  return `${ENDPOINT_ATTACHMENT}resource${v2}/${encodeURIComponent(
    resourceId
  )}?_csrftoken=${csrftoken}`;
};

const copyAttachments = (
  fromEntityId,
  fromEntityType,
  toEntityId,
  toEntityType,
  attachmentTypes
) => {
  const baseUrl = ENDPOINT_ATTACHMENT;
  const encodedAttachmentTypes = _.map(attachmentTypes, (attachmentType) =>
    encodeURIComponent(attachmentType)
  );
  const endpointToUse = `${baseUrl}copy/${fromEntityId}/${fromEntityType}/${toEntityId}/${toEntityType}${
    attachmentTypes ? `?attachmentTypes=${_.join(encodedAttachmentTypes, ',')}` : ''
  }`;
  return fetch(endpointToUse, {
    method: 'POST',
    headers: commonJwtHeader(),
  });
};

function queryParam({key, value}) {
  if (value !== undefined && value !== null && value !== '') {
    if (value instanceof Array) {
      return _.map(value, (p) => `${key}=${p}`).join('&');
    }
    return `${key}=${value}`;
  }
  return '';
}

const searchAttachmentsExternal = ({
  entityId,
  entityType,
  searchTerm,
  searchColumns,
  attachmentTypes,
  excludeAttachmentTypes,
  pageSize,
  pageNum,
  sortBy,
  sortDir,
}) => {
  return searchAttachments({
    entityId,
    entityType,
    searchTerm,
    searchColumns,
    attachmentTypes,
    excludeAttachmentTypes,
    pageSize,
    pageNum,
    sortBy,
    sortDir,
    visibility: 'external',
  });
};

const searchAttachments = ({
  entityId,
  entityType,
  searchTerm,
  searchColumns,
  attachmentTypes,
  excludeAttachmentTypes,
  pageSize,
  pageNum,
  sortBy,
  sortDir,
  visibility,
}) => {
  const baseUrl = ENDPOINT_ATTACHMENT;
  const encodedSearchTerm = searchTerm ? encodeURIComponent(searchTerm) : undefined;
  let endpointToUse =
    visibility == 'external'
      ? `${baseUrl}entity/${entityId}/entityType/${entityType}/search/external`
      : `${baseUrl}entity/${entityId}/entityType/${entityType}/search`;
  const encodedAttachmentTypes = _.map(attachmentTypes, (attachmentType) =>
    encodeURIComponent(attachmentType)
  );
  const queryString = [
    {key: 'searchTerm', value: encodedSearchTerm},
    {key: 'searchColumns', value: searchColumns},
    {key: 'attachmentTypes', value: encodedAttachmentTypes},
    {key: 'excludeAttachmentTypes', value: excludeAttachmentTypes},
    {key: 'pageSize', value: pageSize},
    {key: 'pageNum', value: pageNum},
    {key: 'sortBy', value: sortBy},
    {key: 'sortDir', value: sortDir},
  ]
    .map(queryParam)
    .filter((q) => q)
    .join('&');

  endpointToUse = queryString ? `${endpointToUse}?${queryString}` : endpointToUse;
  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  deleteAttachment,
  callGetAttachmentsByEntityIdAndEntityTypeAndAttachmentType,
  getAttachmentsByEntityIdAndEntityType,
  getAttachmentDownloadUrl,
  getAttachmentDownloadPresignedUrl,
  copyAttachments,
  searchAttachments,
  searchAttachmentsExternal,
};
